import React, {useEffect} from 'react';
import {Button, Input} from "@mui/material";
import {useState} from "react";
import PrevAndNextComponent from "../components/PrevAndNextComponent";
import HeaderWithSubHeader from "../components/HeaderWithSubHeader";
import TextQuestionWithIcon from "../components/TextQuestionWithIcon";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";

const numbers = Array.from({ length: 10 }, (_, index) => index + 1);

const Emotion = ({step, steps, handleNext, handleBack, activeStep, handleSetStepSummary}) => {

    const [inputValue, setInputValue] = useState(steps[activeStep].summary);
    const [thought, setThought] = useState(null);
    const [emotion, setEmotion] = useState(null);
    // Event handler to update the input value
    const handleChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleLocalNext = () => {
        handleSetStepSummary({...step, summary: inputValue, thoughtScale: thought, emotionScale: emotion});
        handleNext();
    };

    useEffect(() => {
        setThought(steps[activeStep].thoughtScale);
        setEmotion(steps[activeStep].emotionScale);
    }, [steps, activeStep]);

    return (
        <div style={{display: "flex", justifyContent: "flex-start", flexDirection: "column", textAlign: "left", fontSize: "24px"}}>
            <HeaderWithSubHeader steps={steps} step={step}/>
            <br/>
            <TextQuestionWithIcon
                text="On a scale from 1 to 10, how strongly do you believe in your thought?"
                icon={<ArrowCircleRightOutlinedIcon />}
                subtitle="1: Do not believe; 10: Strongly believe"
            />

            <div style={{display: "flex", justifyContent: "space-evenly", alignItems: "center", flexWrap: "wrap"}}>
                {numbers.map((num) => {
                    return <Button key={`first-${num}`} variant={thought && thought === num? 'contained' : 'outlined'} style={{borderRadius: "100px"}} onClick={() => setThought(num)}>{num}</Button>;
                })}
            </div>
            <br/>
            <br/>
            <TextQuestionWithIcon
                text="What emotion does this thought make you feel?"
                icon={<ArrowCircleRightOutlinedIcon />}
                subtitle="e.g., scared, ashamed, stressed, discouraged"
            />
            <Input placeholder="Enter emotion here" value={inputValue} onChange={handleChange}></Input>

            <br/>
            <br/>

            <TextQuestionWithIcon
                text="On a scale from 1 to 10, how strong is this emotion?"
                icon={<ArrowCircleRightOutlinedIcon />}
                subtitle="1: Not strong; 10: Extremely strong"
            />

            <div style={{display: "flex", justifyContent: "space-evenly", alignItems: "center", flexWrap: "wrap"}}>
                {numbers.map((num) => {
                    return <Button key={`second-${num}`} variant={emotion && emotion === num? 'contained' : 'outlined'} style={{borderRadius: "100px"}} onClick={() => setEmotion(num)}>{num}</Button>;
                })}
            </div>
            <br/>
            <PrevAndNextComponent steps={steps} activeStep={activeStep} handleBack={handleBack} handleLocalNext={handleLocalNext} />
        </div>
    );
}

export default Emotion;